/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import Field from '@data-driven-forms/react-form-renderer/dist/cjs/field';

export function generateGridTemplate(fields: Field[]) {
  let gridTemplateColumns = '';
  const tmpColumnNumber = 12;
  let shifted = 0;

  for (let i = 0; i < tmpColumnNumber - shifted; i++) {
    if (fields?.length && fields[i]?.colStart > 1) {
      gridTemplateColumns += ' 1fr'.repeat(fields[i].colStart - shifted - i - 1);
      gridTemplateColumns += fields[i]?.colWidth ? ' ' + fields[i].colWidth : ' 1fr';
      shifted += fields[i].colStart - shifted - i - 1;
    } else {
      gridTemplateColumns += fields[i]?.colWidth ? ' ' + fields[i].colWidth : ' 1fr';
    }
    if (fields?.length && fields[i]?.colSpan > 1 && !fields[i]?.colWidth) {
      gridTemplateColumns += ' 1fr'.repeat(fields[i].colSpan - 1);
      shifted += fields[i].colSpan - 1;
    }
  }

  return gridTemplateColumns;
}
